// JS mirror of `$fds-breakpoints` in app/design/_tokens.scss — change both together.
// Desktop = 1200 (Figma). Moved from 1025 by the Navigation slice.
export const BREAKPOINT_TABLET = 768
export const BREAKPOINT_DESKTOP = 1200

export function isDesktopWidth(width: number): boolean {
    return width >= BREAKPOINT_DESKTOP
}

// Media-query strings for useMediaQuery — the same tiers the SCSS mixins use
// (`mobileOnly` stops 0.02px short of the tablet floor, so does MEDIA_PHONE_ONLY).
export const MEDIA_TABLET_UP = `(min-width: ${BREAKPOINT_TABLET}px)`
export const MEDIA_DESKTOP_UP = `(min-width: ${BREAKPOINT_DESKTOP}px)`
export const MEDIA_PHONE_ONLY = `(max-width: ${BREAKPOINT_TABLET - 0.02}px)`
export const MEDIA_COARSE_POINTER = '(pointer: coarse)'
export const MEDIA_HOVER = '(hover: hover)'
